module.exports = "<div class=form-field> <div ng-if=!$ctrl.hideLabel ng-class=[$ctrl.labelClass] class=form-field-label> {{ $ctrl.label }} </div> <div ng-class=[$ctrl.inputClass] class=form-field-input> <input ng-model=$ctrl.value ng-required=$ctrl.isRequired ng-class=\"{'invalid': $ctrl.parentForm[$ctrl.fieldName].$invalid}\" ng-pattern=$ctrl.pattern name=\"{{ $ctrl.fieldName }}\" placeholder=\"{{ $ctrl.placeholder }}\" type=\"{{ $ctrl.type }}\" class=form-control ng-change=\"$ctrl.onValueChange({value: $ctrl.value, fieldName: $ctrl.fieldName})\"> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/form-fields/text-field/text-field.html
// module id = 348
// module chunks = 0